import { Box, FormControlLabel, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)({
  width: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center",
  height: "auto",
});

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  borderBottom: "1px solid #ebebf7",
  padding: `${theme.spacing(1)} 0`,
  margin: 0,
  width: "100%",
}));

export const StyledInputsWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "16px",
});

export const IntervalInput = styled(TextField)({
  marginRight: "4px",
});
